import {
  AI_GENERATED_DETECTION_IS_PREVIEW,
  AUDIO_IS_PREVIEW,
  FACE_DETECTION_IS_PREVIEW,
  LINK_SAFETY_IS_PREVIEW,
  PERSON_DETECTION_IS_PREVIEW,
  PERSONAL_INFORMATION_IS_PREVIEW,
  VIDEO_IS_PREVIEW,
  WEBSITE_IS_PREVIEW,
} from "./SharedConstants";

/**
 * Features that can be in preview. Audio and video are keyed by their asset type, the detections by
 * their `processingOptions.features` key, link safety by its policy section, and moderation categories by their category ID.
 */
const PREVIEW_FEATURES = {
  website: WEBSITE_IS_PREVIEW,
  audio: AUDIO_IS_PREVIEW,
  video: VIDEO_IS_PREVIEW,
  personDetection: PERSON_DETECTION_IS_PREVIEW,
  faceDetection: FACE_DETECTION_IS_PREVIEW,
  "personal-information": PERSONAL_INFORMATION_IS_PREVIEW,
  aiGeneratedDetection: AI_GENERATED_DETECTION_IS_PREVIEW,
  linkSafety: LINK_SAFETY_IS_PREVIEW,
} as const;

export type PreviewFeature = keyof typeof PREVIEW_FEATURES;

/** Whether any of the features is in preview. Anything that isn't a preview feature never is. */
export const isPreview = (feature: string | readonly string[]): boolean =>
  (typeof feature === "string" ? [feature] : feature).some(
    (item) => Object.hasOwn(PREVIEW_FEATURES, item) && PREVIEW_FEATURES[item as PreviewFeature],
  );
